import fetch from 'utils/fetch';
import {
  DomainObject,
  Params,
  Result,
  EadNode,
  ArchivalAidMetadata,
  ArchivalUnitCopy,
  ArchivalCollection,
} from 'types';
import { SortOrder } from 'enums';
import { queryClient } from 'index';
import { useQuery } from 'react-query';

const collectionApi = '/api/archival-collection/list';
const aidsApi = '/api/archival-aid-metadata/list';

// pouziva sa v search v2, TODO: cleanup
export const useArchivalCollectionsList = () => {
  const response = useQuery(['collections'], () =>
    fetch(collectionApi, {
      method: 'POST',
      body: JSON.stringify({
        sort: [{ field: 'name', order: 'ASC' as SortOrder }],
        size: -1,
      }),
      headers: new Headers({ 'Content-Type': 'application/json' }),
    }).then(async (r) => (await r.json()) as Result<ArchivalCollection>)
  );
  return response;
};

export const useArchivalAidsList = () => {
  const response = useQuery(['aids'], () =>
    fetch(aidsApi, {
      method: 'POST',
      body: JSON.stringify({
        sort: [{ field: 'name', order: 'ASC' as SortOrder }],
        size: -1,
      }),
      headers: new Headers({ 'Content-Type': 'application/json' }),
    }).then(async (r) => (await r.json()) as Result<ArchivalAidMetadata>)
  );
  return response;
};

export const useArchivalAidsListByCollection = (
  collectionId: string,
  active: boolean
) => {
  const response = useQuery(
    ['aids', collectionId],
    () =>
      fetch(aidsApi, {
        method: 'POST',
        body: JSON.stringify({
          filters: [
            {
              field: 'archivalCollection.id',
              operation: 'EQ',
              value: collectionId,
            },
          ],

          size: -1,
        }),

        headers: new Headers({ 'Content-Type': 'application/json' }),
      }).then(async (r) => (await r.json()) as Result<ArchivalAidMetadata>),
    { enabled: active }
  );

  return {
    aids: response.data?.items ?? [],
    loading: response.isLoading,
  };
};

export const fetchEadChildren = async (ids: string[]) => {
  const body = [...ids];
  console.log('fett ead children', process.env.PUBLIC_URL, ids);
  const resp = await queryClient.fetchQuery(['children', ...ids], () =>
    fetch('/api/archival-aid-metadata/ead/list', {
      method: 'POST',
      body: JSON.stringify(body),
      headers: new Headers({ 'Content-Type': 'application/json' }),
    }).then(async (r) => ((await r.json()) as unknown) as EadNode[])
  );
  return resp;
};

export const fetchAidChildren = async (aid: ArchivalAidMetadata) => {
  const body = {
    sort: [{ field: 'numericId', order: 'ASC' }],
    filters: [
      {
        field: 'describingArchivalAids.id',
        operation: 'EQ',
        value: aid.id,
      },

      // {
      //   field: 'describingArchivalAids.invalidated',
      //   operation: 'EQ',
      //   value: false,
      // },
    ],
    size: -1,
  };

  const resp = await queryClient.fetchQuery(['aid-children', aid.id], () =>
    fetch('/api/archival-unit/public/list', {
      method: 'POST',
      body: JSON.stringify(body),
      headers: new Headers({ 'Content-Type': 'application/json' }),
    }).then(
      async (r) => ((await r.json()) as unknown) as Result<ArchivalUnitCopy>
    )
  );
  return resp;
};

export const useAidsListByOriginator = (id?: string) =>
  useQuery(
    ['originator-list', id],
    () =>
      fetch(
        `/api/archival-aid-metadata/list-by-originator?originatorId=${id}`
      ).then(
        async (r) => (await r.json()) as Record<string, ArchivalAidMetadata[]>
      ),
    { enabled: !!id }
  );

///// OLD //////

export async function fetchList<TObject extends DomainObject>(
  url: string,
  defaultParams: Params = {}
): Promise<Result<TObject>> {
  const {
    sort = [{ field: 'name', order: SortOrder.ASC }],
    filters = [],
    size = 20,
    searchAfter,
  } = defaultParams;

  const params: Params = {
    sort,
    filters,
    size,
    searchAfter,
  };
  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(params),
    headers: new Headers({ 'Content-Type': 'application/json' }),
  });

  const json = await response.json();

  return json;
}

export async function fetchDetail<T>(url: string) {
  const response = await fetch(url, {
    method: 'GET',
    headers: new Headers({ 'Content-Type': 'application/json' }),
  });

  const json: T = await response.json();

  return json;
}
